var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('Header'),_c('el-main',[_c('router-view')],1),_c('el-footer',{staticClass:"main-footer"},[_c('span',{staticClass:"font-size-small"},[_vm._v("Magnet (c) 2021")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }